/**
 * Return all the property we want to track out of an mcart product
 * @param {IProduct} product - product model received from the API
 * @param {object} extraProps - optional tracking properties
 * @returns {object} object containing all the tracking properties we need to communicate to the tracking api
 */
export default function getProductData(product, extraProps = {}) {
    const data = { ...product, ...extraProps };
    const { price_information } = data;
    return {
        name: data.name,
        id: data.product_id || data.id,
        price: price_information.original_price || price_information.price,
        position: data.position,
        discountedprice: price_information.original_price ? price_information.price : null,
        discountamount: price_information.discount_amount,
        discounttype: price_information.discount_type,
        quantity: data.quantity || data.amount,
        brand: data.brand_name,
        creative: data.creative,
        rubrik: price_information.discount_type,
        laufzeit: price_information.discount_duration,
        category: data.tracking_category,
        variant: data.variant,
    };
}

export function prepareProductsData(products) {
    products = Object.keys(products).map((e) => {
        return products[e];
    });
    return products.map(i => Object.assign({}, i.product, { quantity: i.amount }));
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/tracking/get-product-data.js